export default __webpack_public_path__ + "static/green-school_2-744b025f2f008cdd19425d8ff35881c0.png";